var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXFLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#7AB2D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.091 13.7264C28.4224 14.0163 27.6947 14.2249 26.9453 14.3062C27.7234 13.8416 28.3061 13.1075 28.5841 12.2418C27.8539 12.6784 27.054 12.9845 26.2198 13.1466C25.8712 12.772 25.4495 12.4736 24.9811 12.2699C24.5127 12.0663 24.0076 11.9618 23.4973 11.9629C21.4324 11.9629 19.7718 13.6452 19.7718 15.7095C19.7718 15.9994 19.8067 16.2893 19.8635 16.5682C16.7717 16.4057 14.0141 14.9211 12.1809 12.6481C11.8468 13.2216 11.6718 13.8745 11.6739 14.539C11.6739 15.8391 12.3316 16.9855 13.3346 17.6597C12.7435 17.6363 12.1663 17.4731 11.6499 17.1832V17.2293C11.6499 19.0499 12.9304 20.5587 14.6369 20.9056C14.3165 20.9893 13.9868 21.0321 13.6558 21.033C13.4132 21.033 13.1838 21.0089 12.9522 20.9759C13.4242 22.4605 14.7986 23.5388 16.4352 23.574C15.1547 24.582 13.5509 25.175 11.8094 25.175C11.497 25.175 11.2085 25.164 10.9092 25.1289C12.5611 26.194 14.5211 26.8089 16.6318 26.8089C23.4842 26.8089 27.2337 21.1033 27.2337 16.151C27.2337 15.9885 27.2337 15.8259 27.2228 15.6634C27.9482 15.1298 28.5841 14.4687 29.091 13.7264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXFLogo);
export default __webpack_public_path__ + "static/media/xFLogo.ac2410d20e38586c9521d3ac8d879a00.svg";
export { ForwardRef as ReactComponent };